export default __webpack_public_path__ + "static/media/endringshistorie.db2127fa.pdf";